import React, { FC, useCallback } from 'react';
import { Approval } from 'api/approval';
import { TaskStatusType } from 'api/status-updates';
import { ResourceSectionType } from 'data/documents';
import { isTaskApprovalMatchesFilter } from 'data/status-updates';
import { Task } from 'data/tasks';
import { INSERT_RESOURCE_LIST_SECTION_COMMAND } from 'vendor/ckeditor/plugins/resource-list-section';
import { Highlight } from '../highlight';

interface Props {
  tasks: Task[];
  type: ResourceSectionType;
}
export const ApprovalCard: FC<Props> = ({ tasks, type }) => {
  const getStructuredTasks = useCallback(
    (date) => {
      const approvalEntries = tasks.reduce((acc, task) => {
        return [...acc, ...(task.approvals || [])];
      }, [] as Approval[]);

      return {
        [TaskStatusType.Overdue]: approvalEntries.filter((approval) => {
          return isTaskApprovalMatchesFilter(
            TaskStatusType.Overdue,
            date,
            approval,
          );
        }),
        [TaskStatusType.Blocked]: [],
        [TaskStatusType.Completed]: approvalEntries.filter((approval) => {
          return isTaskApprovalMatchesFilter(
            TaskStatusType.Completed,
            date,
            approval,
          );
        }, []),
        [TaskStatusType.Upcoming]: approvalEntries.filter((approval) => {
          return isTaskApprovalMatchesFilter(
            TaskStatusType.Upcoming,
            date,
            approval,
          );
        }),
        resourceKey: 'approvalId',
      };
    },
    [tasks],
  );

  return (
    <Highlight
      commandOptions={{
        resourceSectionType: ResourceSectionType.Approval,
      }}
      commandName={INSERT_RESOURCE_LIST_SECTION_COMMAND}
      getStructuredTasks={getStructuredTasks}
      tasks={tasks}
      type={type}
    />
  );
};
